<template>
	<v-card class="mx-auto" elevation="0">
		<v-card-title v-if="!wizardMode" class="card-header fixed-card-title">
			<v-row dense>
				<v-col class="align-center d-flex" cols="10">
					<v-toolbar-title>{{ $t('add-staff') }}</v-toolbar-title>
				</v-col>
				<v-spacer></v-spacer>
				<v-icon @click="closeDrawer" class="white-icon mr-3">mdi-close</v-icon>
			</v-row>
		</v-card-title>

		<v-card-text class="mt-16">
			<v-form ref="form" lazy-validation>
				<v-container>
					<v-row class="pt-2">
						<v-col class="d-flex pa-1" cols="6">
							<v-text-field
								outlined
								hide-details
								dense
								v-model="hospitalAdminToAdd.firstName"
								:rules="[(v) => !!v || 'Item is required']"
								:label="$t('first-name')"
								:key="'textField' + componentKey"
								required />
						</v-col>

						<v-col class="d-flex pa-1" cols="6">
							<v-text-field
								outlined
								hide-details
								dense
								v-model="hospitalAdminToAdd.lastName"
								:rules="[(v) => !!v || 'Item is required']"
								:label="$t('last-name')"
								:key="'textField2' + componentKey"
								required />
						</v-col>

						<v-col class="d-flex pa-1" cols="12">
							<v-select
								class="width-text-field2"
								hide-details
								dense
								v-model="hospitalAdminToAdd.roleId"
								:items="filteredRoles"
								item-value="id"
								item-text="roleNameForDisplay"
								:key="'textField5' + componentKey"
								:label="$t('role')"
								outlined
								:menu-props="{ offsetY: true }" />
						</v-col>

						<v-col class="d-flex pa-1" cols="12" v-if="hospitalAdminToAdd.roleId !== 10">
							<v-select
								class="width-text-field2"
								hide-details
								dense
								v-model="hospitalAdminToAdd.organizationId"
								:items="filterOrganizations"
								item-value="id"
								item-text="institutionName"
								:label="$t('medicalInstitution')"
								:key="'textField3' + componentKey"
								@change="setSelectedHospitalOrOrganization"
								outlined
								:menu-props="{ offsetY: true }" />
						</v-col>

						<v-col class="d-flex pa-1" cols="12" v-if="hospitalAdminToAdd.roleId === 6">
							<v-select
								class="width-text-field2"
								hide-details
								dense
								v-model="hospitalAdminToAdd.hospitalId"
								:items="filteredHospitals"
								item-value="id"
								item-text="hospitalName"
								:label="$t('hospital')"
								:key="'textField4' + componentKey"
								@change="setSelectedHospitalOrOrganization"
								outlined />
						</v-col>

						<v-col class="d-flex pa-1" cols="12">
							<div class="pt-4">
								<h5 class="heading text-left">{{ this.$t('address') }}</h5>
							</div>
						</v-col>

						<v-col class="d-flex pa-1" cols="12">
							<v-text-field
								outlined
								hide-details
								dense
								v-model="hospitalAdminToAdd.address"
								:rules="[(v) => !!v || 'Item is required']"
								:label="$t('address')"
								:key="'textField6' + componentKey"
								required />
						</v-col>

						<v-col class="d-flex pa-1" cols="6">
							<v-text-field
								outlined
								hide-details
								dense
								v-model="hospitalAdminToAdd.city"
								:rules="[(v) => !!v || 'Item is required']"
								:label="$t('city')"
								:key="'textField7' + componentKey"
								required
								disabled />
						</v-col>

						<v-col class="d-flex pa-1" cols="6">
							<v-text-field
								outlined
								hide-details
								dense
								v-model="hospitalAdminToAdd.state"
								:rules="[(v) => !!v || 'Item is required']"
								:label="$t('state')"
								:key="'textField8' + componentKey"
								required
								disabled />
						</v-col>

						<v-col class="d-flex pa-1" cols="6">
							<v-text-field
								outlined
								hide-details
								dense
								v-model="hospitalAdminToAdd.zip"
								:rules="[(v) => !!v || 'Item is required']"
								:label="$t('zip')"
								:key="'textField9' + componentKey"
								required
								disabled />
						</v-col>

						<v-col class="d-flex pa-1" cols="6">
							<v-text-field
								outlined
								hide-details
								dense
								v-model="hospitalAdminToAdd.country"
								:rules="[(v) => !!v || 'Item is required']"
								:label="$t('country')"
								:key="'textField10' + componentKey"
								required
								disabled />
						</v-col>

						<v-col class="pa-1" v-if="!addressIsValid">
							<v-combobox
								:label="$t('time-zone')"
								dense
								hide-details
								outlined
								:rules="[(v) => !!v || $t('timeZoneSelect')]"
								v-model="timezone"
								item-text="timeZoneId"
								item-value="timeZoneId"
								:items="getTimeZone"
								:key="componentKey" />
						</v-col>

						<v-col class="d-flex pa-1" cols="12">
							<div class="pt-4">
								<h5 class="heading text-left">{{ $t('contact') }}</h5>
							</div>
						</v-col>

						<v-col class="d-flex pa-1" cols="6">
							<v-text-field
								outlined
								hide-details
								dense
								v-model="hospitalAdminToAdd.phone"
								:rules="[(v) => !!v || 'Item is required']"
								:label="$t('contact-phone')"
								@input="formatPhoneNumber"
								:key="'textField11' + componentKey"
								required />
						</v-col>

						<v-col class="d-flex pa-1" cols="6">
							<v-text-field
								outlined
								hide-details
								dense
								v-model="hospitalAdminToAdd.email"
								:rules="[(v) => !!v || 'Item is required']"
								:label="$t('contact-email')"
								:key="'textField12' + componentKey"
								required />
						</v-col>
					</v-row>
				</v-container>
			</v-form>
		</v-card-text>

		<v-card-actions v-if="!wizardMode" class="fixed-card-actions">
			<v-row dense class="mx-0 px-0 mr-2">
				<v-col cols="6">
					<v-btn @click="closeDrawer" elevation="0" class="cancel-button-style capitalize-text">
						{{ $t('cancel') }}
					</v-btn>
				</v-col>

				<v-col cols="6">
					<v-btn :disabled="isSaveButtonDisabled()" class="save-button-style" @click="saveHospitalAdmin">
						{{ $t('save') }}
					</v-btn>
				</v-col>
			</v-row>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import HospitalAdminEditDto from '../../data/models/HospitalAdminEditDto';
import { showSuccessAlert, showErrorAlert } from '@/utils/utilities';
import { AsYouType } from 'libphonenumber-js';

export default {
	name: 'HopsitalAdminAddDrawer',
	props: {
		wizardMode: {
			type: Boolean,
			default: false,
		},
		wizardData: {
			type: Object,
			default: () => ({}),
		},
	},
	data: () => ({
		componentKey: 0,
		hospitalAdminToAdd: new HospitalAdminEditDto(),
		selectedHospitalOrOrganization: null,
		addressIsValid: true,
		institutions: null,
		timezone: null,
	}),
	async mounted () {
		this.hospitalAdminToAdd.phone = '+1';
		await this.getTimeZones();
		await this.getAllMedicalInstitutions();
		await this.getAllHospitals();

		if (this.wizardMode && this.wizardData) {
			this.initiateWizardAdmin();
		}

		if (this.allMedicalInstitutions.length === 1) {
			this.hospitalAdminToAdd.organizationId = this.allMedicalInstitutions[0].id;
			this.setSelectedHospitalOrOrganization(this.hospitalAdminToAdd.organizationId);
		}
	},
	computed: {
		...mapState({
			allMedicalInstitutions: (state) => state.medicalInstitutions.medicalInstitutions,
			hospitals: (state) => state.hospitals.hospitals,
			allRoles: (state) => state.roles.roles,
			authenticated: (state) => state.authentication.userData,
			detailsDrawer: (state) => state.detailsDrawer,
		}),
		...mapGetters({
			getTimeZone: 'verifiers/getTimeZone',
			getMedicalInstitutions: 'medicalInstitutions/getMedicalInstitutions',
			roleName: 'authentication/getRole',
		}),
		filterOrganizations () {
			if (this.roleName === 'SYSTEM_ADMIN') {
				const institutions = this.allMedicalInstitutions.slice();
				institutions.shift();
				return institutions;
			}
			return this.allMedicalInstitutions;
		},
		filteredHospitals () {
			let calculateFileteredHospital = this.hospitals;
			if (this.hospitalAdminToAdd.organizationId !== null && this.hospitalAdminToAdd.organizationId !== 0) {
				calculateFileteredHospital = calculateFileteredHospital.filter(
					(h) => h.medicalInstitutionId === this.hospitalAdminToAdd.organizationId,
				);
			} else {
				calculateFileteredHospital = this.hospitals;
			}

			if (this.wizardMode) {
				calculateFileteredHospital.push(this.wizardData);
			}

			return calculateFileteredHospital;
		},
		filteredRoles () {
			let filteredRolesReturn = [];

			if (this.roleName === 'SYSTEM_ADMIN') {
				filteredRolesReturn = this.allRoles.filter(
					(r) => r.roleName === 'HOSPITAL_ADMIN' || r.roleName === 'ORGANIZATION_ADMIN' || r.id === 9 || r.id === 10,
				);
			} else if (this.roleName === 'ORGANIZATION_ADMIN') {
				filteredRolesReturn = this.allRoles.filter(
					(r) => r.roleName === 'HOSPITAL_ADMIN' || r.roleName === 'ORGANIZATION_ADMIN' || r.id === 9,
				);
			}

			if (this.wizardMode) {
				filteredRolesReturn = [{ id: 6, roleNameForDisplay: 'Hospital Admin' }];
			}

			return filteredRolesReturn;
		},
	},
	watch: {
		// Add a watcher on hospitalToAdd to check form validity whenever data changes
		hospitalAdminToAdd: {
			deep: true,
			handler () {
				this.checkFormValidity();
			},
		},
	},

	methods: {
		async getPartners () {
			const organizationId = this.roleName === 'SYSTEM_ADMIN' ? -1 : this.authenticated.organizationId;
			const body = {
				organizationId: organizationId,
			};

			await this.$store.dispatch('users/getPartners', body);
		},

		initiateWizardAdmin () {
			this.hospitalAdminToAdd.firstName = 'HospitalAdmin';
			this.hospitalAdminToAdd.lastName = this.wizardData.hospitalName;
			this.hospitalAdminToAdd.roleId = 6;
			this.hospitalAdminToAdd.organizationId = this.wizardData.medicalInstitutionId;
			this.setSelectedHospitalOrOrganization(this.hospitalAdminToAdd.organizationId);
			this.hospitalAdminToAdd.hospitalId = this.wizardData.id;
			this.hospitalAdminToAdd.phone = this.wizardData.contactPhone || '+1';
			this.hospitalAdminToAdd.email = this.wizardData.contactEmail || '';
		},

		isSaveButtonDisabled () {
			return (
				!this.hospitalAdminToAdd.firstName ||
				!this.hospitalAdminToAdd.lastName ||
				!this.hospitalAdminToAdd.roleId ||
				!this.hospitalAdminToAdd.address ||
				!this.hospitalAdminToAdd.city ||
				!this.hospitalAdminToAdd.state ||
				!this.hospitalAdminToAdd.zip ||
				!this.hospitalAdminToAdd.country ||
				!(this.hospitalAdminToAdd.phone.length > 10) ||
				!this.hospitalAdminToAdd.email
			);
		},

		checkFormValidity () {
			// We invert the result of isSaveButtonDisabled
			const newValidity = !this.isSaveButtonDisabled();

			// Only emit if the status has actually changed to avoid excessive updates
			if (this.isValid !== newValidity) {
				this.isValid = newValidity;
				// Emit the current validity status to the parent
				this.$emit('update:wizard-valid', newValidity);
			}
		},

		getTimeZones () {
			this.$store.dispatch('verifiers/getTimeZones').then(() => {});
		},
		setSelectedHospitalOrOrganization (val) {
			if (this.hospitalAdminToAdd.roleId === 6) {
				this.selectedHospitalOrOrganization = this.hospitals.find((hospital) => hospital.id === val);
				// eslint-disable-next-line no-empty
				if (this.selectedHospitalOrOrganization !== undefined && this.selectedHospitalOrOrganization !== null) {
				} else {
					return;
				}
			} else {
				this.selectedHospitalOrOrganization = this.allMedicalInstitutions.find((org) => org.id === val);
			}

			this.hospitalAdminToAdd.address = this.selectedHospitalOrOrganization.address;
			this.hospitalAdminToAdd.city = this.selectedHospitalOrOrganization.city;
			this.hospitalAdminToAdd.state = this.selectedHospitalOrOrganization.state;
			this.hospitalAdminToAdd.zip = this.selectedHospitalOrOrganization.zip;
			this.hospitalAdminToAdd.country = this.selectedHospitalOrOrganization.country;
			if (
				this.selectedHospitalOrOrganization?.addressLatitude !== 0.01 &&
				this.selectedHospitalOrOrganization.addressLongitude !== 0.01 &&
				this.selectedHospitalOrOrganization.addressLongitude !== null &&
				this.selectedHospitalOrOrganization?.addressLatitude !== null
			) {
				// TODO there is good address call  edpoint for geting the correct time zone with given lan lng

				this.addressIsValid = true;

				const latLng = {
					lat: this.selectedHospitalOrOrganization?.addressLatitude,
					lng: this.selectedHospitalOrOrganization.addressLongitude,
				};

				this.$store.dispatch('googleAPI/getTimeZone', latLng).then((response) => {
					this.timezone = response.zoneName;
				});
			} else {
				// TODO There is bad address show time zoene lookup
				this.addressIsValid = false;
				this.selectedHospitalOrOrganization.addressLatitude = 0.01;
				this.selectedHospitalOrOrganization.addressLongitude = 0.01;
			}
		},
		formatPhoneNumber (val) {
			this.hospitalAdminToAdd.phone = new AsYouType().input(val);
		},
		resetComponent () {
			// Reset firstname or any other component state as needed
			this.hospitalAdminToAdd.firstName = '';
			this.hospitalAdminToAdd.lastName = '';
			this.hospitalAdminToAdd.organizationId = '';
			this.hospitalAdminToAdd.hospitalId = '';
			this.hospitalAdminToAdd.roleId = '';
			this.hospitalAdminToAdd.address = '';
			this.hospitalAdminToAdd.city = '';
			this.hospitalAdminToAdd.state = '';
			this.hospitalAdminToAdd.zip = '';
			this.hospitalAdminToAdd.country = '';
			this.hospitalAdminToAdd.phone = '+1';
			this.hospitalAdminToAdd.email = '';

			// Change the key to trigger component reset
			this.componentKey += 1;
		},
		async getOrganizationAmdinUsers () {
			await this.$store.dispatch('users/getOrganizationAdmins').then(() => {
				this.closeDrawer();
			});
		},
		async getHospitalAmdinsUsers () {
			// await this.$store.dispatch('hospitals/getHospitalAdmins').then(() => {
			await this.$store.dispatch('users/getHospitalAdmins').then(() => {
				this.closeDrawer();
			});
		},
		async getCaregivers () {
			await this.$store.dispatch('users/getCaregivers').then(() => {
				this.closeDrawer();
			});
		},
		async getAllMedicalInstitutions () {
			// we call this API endpoint only if the store values are null
			if (this.allMedicalInstitutions == null) {
				await this.$store.dispatch('medicalInstitutions/getMedicalInstitutions').then(() => {
					// this.loading = false;
				});
			}
		},
		async getAllHospitals () {
			// we call this API endpoint only if the store values are null
			if (this.hospitals == null) {
				await this.$store.dispatch('hospitals/getHospitals').then(() => {
					// this.loading = false;
				});
			}
		},
		async saveHospitalAdmin () {
			const waitAddressValidation = await this.checkAndFixLocationDetails();
			if (!waitAddressValidation) {
				// this.validationErrors.push('address');
				// go on with the given addres data
			}

			this.hospitalAdminToAdd.phone = new AsYouType().input(this.hospitalAdminToAdd.phone); // TODO: this we need to do ONLY on presentation, NOT when saving on DB

			if (this.$refs.form.validate()) {
				const body = {
					firstName: this.hospitalAdminToAdd.firstName,
					lastName: this.hospitalAdminToAdd.lastName,
					phone: this.hospitalAdminToAdd.phone,
					email: this.hospitalAdminToAdd.email,
					address: this.hospitalAdminToAdd.address,
					zip: this.hospitalAdminToAdd.zip,
					city: this.hospitalAdminToAdd.city,
					state: this.hospitalAdminToAdd.state,
					country: this.hospitalAdminToAdd.country,
					addressLatitude: this.selectedHospitalOrOrganization?.addressLatitude,
					addressLongitude: this.selectedHospitalOrOrganization?.addressLongitude,
					username: this.hospitalAdminToAdd.email,
					status: 1, // this.hospitalAdminToAdd.status,
					// gender: this.hospitalAdminToAdd.gender,
					// birthdate: this.hospitalAdminToAdd.birthdate,
					roleId: this.hospitalAdminToAdd.roleId,
					// userTimezone: this.hospitalAdminToAdd.userTimezone,
					// userSettingsJson: this.hospitalAdminToAdd.userSettingsJson,
					// language: this.hospitalAdminToAdd.language,
					// hospitalId: this.hospitalAdminToAdd.hospitalId,
					organizationId: this.hospitalAdminToAdd.roleId === 10 ? -1 : this.hospitalAdminToAdd.organizationId,
					userTimezone: this.addressIsValid ? this.timezone : this.timezone.timeZoneId,
				};

				if (this.hospitalAdminToAdd.roleId === 6) {
					body.hospitalId = this.hospitalAdminToAdd.hospitalId;
				}
				await this.$store.dispatch('users/createUser', body).then((res) => {
					if (res) {
						showSuccessAlert(this.$t('success-operation'));
						if (this.hospitalAdminToAdd.roleId === 6) {
							this.getHospitalAmdinsUsers(); // reload the list of hospital admins
						} else if (this.hospitalAdminToAdd.roleId === 8) {
							this.getOrganizationAmdinUsers(); // reload the list of organization admins
						} else if (this.hospitalAdminToAdd.roleId === 7) {
							this.getCaregivers(); // reload the list of caregivers
						} else if (this.hospitalAdminToAdd.roleId === 9) {
							this.closeDrawer();
							this.getPartners(); // reload the list of caregivers
						}
						if (!this.wizardMode) {
							this.resetComponent();
							this.closeDrawer();
						}
					} else {
						showErrorAlert(this.$t('failed-operation'));
					}
				});
			} else {
				this.$refs.form.validate();
			}
		},
		closeDrawer () {
			this.hospitalAdminToAdd = new HospitalAdminEditDto();
			this.resetComponent();
			this.$store.commit('SET_DETAILS_DRAWER', false);
		},
		async checkAndFixLocationDetails () {
			try {
				const h = this.hospitalAdminToAdd;
				if (h.address) {
					const addressForValidation = `${h.address}`;
					const geoLocation = await this.$store.dispatch('googleAPI/getGeoLocation', addressForValidation);

					if (!geoLocation || !geoLocation.address_components || !geoLocation.geometry) {
						h.addressLatitude = 0.01;
						h.addressLongitude = 0.01;
						return false;
					}

					const components = geoLocation.address_components;
					const getComponent = (type) => {
						const found = components.find((c) => c.types.includes(type));
						return found ? found.long_name : 'N/A';
					};

					// Extract and set location info
					const lat = geoLocation.geometry.location.lat || 0.01;
					const lng = geoLocation.geometry.location.lng || 0.01;

					h.addressLatitude = lat;
					h.addressLongitude = lng;
					h.address = geoLocation.formatted_address || h.address;
					h.city =
						getComponent('locality') ||
						getComponent('sublocality') ||
						getComponent('administrative_area_level_2') ||
						'N/A';
					h.state = getComponent('administrative_area_level_1') || 'N/A';
					h.country = getComponent('country') || 'N/A';
					h.zip = getComponent('postal_code') || 'N/A';

					this.addressIsValid = true;
					// this.timezone = addressComponents.timezone || 'N/A';

					// Now call Time Zone API
					const timestamp = Math.floor(Date.now() / 1000); // current time in seconds
					const timeZoneResponse = await fetch(
						`https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${process.env.VUE_APP_GOOGLEMAPAPIKEY}`,
					);
					const timeZoneData = timeZoneResponse.json();

					if (timeZoneData.status === 'OK') {
						h.timeZoneId = timeZoneData.timeZoneId; // e.g., "Europe/Skopje"
						h.timeZoneName = timeZoneData.timeZoneName; // e.g., "Central European Summer Time"
						h.rawOffset = timeZoneData.rawOffset; // base offset in seconds
						h.dstOffset = timeZoneData.dstOffset; // daylight savings offset in seconds
						h.hospitalTimeZone = timeZoneData.timeZoneId;
					} else {
						// If timezone fetch failed, set default or null
						h.timeZoneId = 'N/A';
						h.timeZoneName = 'N/A';
						h.rawOffset = 0;
						h.dstOffset = 0;
						h.hospitalTimeZone = this.defaultTimeZone;
					}

					return true;
				} else {
					h.addressLatitude = 0.01;
					h.addressLongitude = 0.01;
					return false;
				}
			} catch (error) {
				this.hospitalAdminToAdd.addressLatitude = 0.01;
				this.hospitalAdminToAdd.addressLongitude = 0.01;
				this.hospitalAdminToAdd.hospitalTimeZone = this.defaultTimeZone;
				return false;
			}
		},
	},
};
</script>
